import { Charts } from './Charts';
import CrimesChartsDataProvider from './contexts/CrimesChartsDataContext';

const CrimesWrapper = () => {
    return (
        <CrimesChartsDataProvider>
            <Charts />
        </CrimesChartsDataProvider>
    );
};

export default CrimesWrapper;
